import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { KnowledgeSummary } from '@/types'
import { DUMMY_SUMMARY } from '@/lib/dummyData'

export function useKnowledgeSummary() {
  const [summary, setSummary] = useState<KnowledgeSummary[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.rpc('get_knowledge_summary').then(({ data, error }) => {
      setSummary(!error && data && data.length > 0 ? data : DUMMY_SUMMARY)
      setLoading(false)
    })
  }, [])

  const getCount = (contentType: string) =>
    summary.find(s => s.content_type === contentType)?.cnt ?? 0

  return { summary, loading, getCount }
}
